var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component",attrs:{"record":_vm.active,"amount":_vm.amount}})}
var staticRenderFns = []

export { render, staticRenderFns }